export default "__VITE_ASSET__BhPi7Y10__"